class BuildingBlocksSDK {
  static create (schema) {
    BuildingBlocksSDK.builderApi.editor.activatePopover(schema)
  }
}

export default BuildingBlocksSDK
